/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class EncryptionService {

  iv = CryptoJS.enc.Base64.parse(environment.iv);
  key = CryptoJS.SHA256(environment.key);
  encryptedString: any;
  secretKey: any = 'social_ADMIN';

  encryptData(data: any): any {
    this.encryptedString = CryptoJS.AES.encrypt(JSON.stringify(data), this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return this.encryptedString.toString();
  }

  decryptData(encrypted: any): any {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  encryptLocalStorage(data: any, key: string): any {
    const encyrpted = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
    localStorage.setItem(key, encyrpted);
  }

  decryptLocalStorage(key: string): any {
    if (key) {
      const data = localStorage.getItem(key);
      if (data) {
        const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
        const recieved = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(recieved);
      }
    }
  }

  encryptHeaders(data: any, type = 'header'): any {
    if (typeof data === 'string') {
      data = data.slice();
      this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
    } else {
      this.encryptedString = CryptoJS.AES.encrypt(JSON.stringify(data), this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
    }

    if (type === 'query' && this.encryptedString.toString().includes('+')) {
      this.encryptedString = this.encryptedString
        .toString()
        .split('+')
        .join(environment.storageKey);
    }

    return this.encryptedString.toString();
  }

  encryptionPayload(data: any): any {
    data = data.slice();
    this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return this.encryptedString.toString();
  }
}
